import { AnalyticsService } from '../analytics/analytics.service';
import { ActivatedRoute, NavigationEnd } from '@angular/router';
import { AuthService, User } from '../user/auth.service';
import { FormControl } from '@angular/forms';
import { UnsplashImageService } from '../unsplash/unsplash.service';
import { Urls } from '../unsplash/unsplash.response';
import { RegistryFirebaseService } from '../registry/registry-firebase.service';
import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { Result } from '../unsplash/unsplash.response';
import { RegistryService } from '../registry/registry.service';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Registry } from '../registry/registry';
import { Gift } from '../gift/gift';

@Component({
  selector: 'app-welcome-popup',
  templateUrl: './reg-font-popup.component.html',
  styleUrls: ['./reg-font-popup.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  host: {
    '(document:keydown)': 'handleKeyboardEvents($event)'
  }
})


export class RegFontPopupComponent implements OnInit {
  @ViewChild('serachQuery') firstNameElement: ElementRef;
  hide: boolean;
  user: User;
  registry: Registry;
  selectionMade = false;


  @Input() showPopup = false;
  constructor(private _unsplashImageService: UnsplashImageService,
    private _registryService: RegistryService,
    private _authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private _registryFirebaseService: RegistryFirebaseService,
    private _analyticsService: AnalyticsService

  ) {


    this._registryService.handlePopupScrollBars(this.router);
   

  }




  handleKeyboardEvents(event: any) {
    if (this.showPopup && event.keyCode === 27) {

      this.close();
    }



  }





  expandTextArea(textArea: HTMLTextAreaElement) {
    textArea.rows = 2;
    const height = textArea.scrollHeight;
    textArea.rows = Math.floor(height / 16); // 20px = line-height: 1.25rem
  }

  createDefaultGifts() {

  }


  ngOnInit() {

    this.user = this.route.snapshot.data.user;
   if (!this.registry){
    this.registry = this.route.snapshot.data.registry;

    if(!this.registry && location.pathname.includes('your-registry')){
      this.registry = this._registryFirebaseService.getAnonRegistry();
    }
    this._registryFirebaseService.currentRegistry.subscribe(registry => {

      if (registry) {
        this.registry = registry;        
      }
    });
    if (this.registry && !this.registry.font){
      this.registry.font = 'classic';
    }
   }


   this._registryService.showGenericPopup$.subscribe(popupType => {

    if (popupType == "font"){
    this.showPopup = true;
    const body = document.getElementsByTagName('body')[0];    
    body.style.overflow = 'hidden';
    } else {
      this.close();
    }

  });


  }
  updateReg(skipClose = false) {

    if(this._registryFirebaseService.isAnonRegPath()){
      this._registryFirebaseService.saveAnonRegistry(this.registry)
      if(!skipClose){
        this.close();
        }
      return;
     }
    this._registryFirebaseService.updateRegFont(this.registry);
    if(!skipClose){
      this.close();
      }
  }
  updateUser(): Promise<any> {
    this.user.dismissCreatePopup = true;
    return this._registryFirebaseService.updateUser(this.user);

  }


  giftAssistant() {
    this.updateUser().then(() => {

        this.router.navigate(['/registry/gift-assistant']);

    });

  }


  enableFontToGiftTitles(){
    this.registry.applyFontToGiftTitles=!this.registry.applyFontToGiftTitles
    
    this.selectionMade = true;
  }

  createGift() {
    this.updateUser().then(() => {

        this.router.navigate(['/registry/create-gift']);

    });

  }


  close() {

    if(!this.showPopup) {
      return;
    }
    this.updateReg(true);
    this.showPopup = false;
    //this.router.navigate(['registry']);
    const body = document.getElementsByTagName('body')[0];
    body.style.overflow = 'auto';
    //this._registryService.emitHeaderPopupClosed();
 //   this._registryService.emitGenricPopup('close');

  }

}



// WEBPACK FOOTER //
// ./src/app/reg-font-popup/reg-font-popup.component.ts